<div class="config-wrapper">
	<span class="phb-icon icon--settings" (click)="showSettings()"></span>
</div>
